<template>
  <v-card color="neutral600 mt-5 mx-4">
    <v-card-text class="px-8" v-show="!!src">
      <div class="d-flex align-center">
        <v-avatar size="14" class="mr-2">
          <img :src="require('@/assets/icons/sound_active.svg')" />
        </v-avatar>
        {{ fileName }}
      </div>

      <div class="d-flex align-center mt-5">
        <v-btn
          fab
          small
          depressed
          color="neutral500"
          class="mr-2"
          @click="playPause"
        >
          <v-icon>mdi-{{ isPause ? 'play' : 'pause' }}</v-icon>
        </v-btn>

        <v-slider
          v-model="t"
          class="progress_bar"
          :max="length"
          @change="setTime"
          @mousedown="sliderMousedown"
          @mouseup="sliderMouseup"
          :hint="`${$s2hms(t / timeMagnifier)} / ${$s2hms(
            length / timeMagnifier
          )}`"
          persistent-hint
        ></v-slider>
      </div>

      <audio
        ref="PlayerEl"
        preload="metadata"
        @ended="onEnd"
        @playing="timeupdate"
        @timeupdate="timeupdate"
        @play="onPlay"
        @pause="onPause"
        @loadedmetadata="loadMeta"
      >
        <source :src="blobUrl || src" />
      </audio>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    fileName: {
      type: String,
      default: ''
    },
    file: {
      type: [File, String, Object, Blob],
      default: null
    },
    src: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      blobUrl: '',

      t: 0,
      length: 0,
      isPause: true,
      audioData: null,
      timeMagnifier: 1000,
      isPlayerRender: false
    };
  },

  watch: {
    step() {
      this.pause();
    }
  },

  mounted() {
    if (this.file) {
      this.blobUrl = URL.createObjectURL(this.file);
    }
    this.mediaReady();
  },

  beforeDestroy() {
    this.mediaDestroy();
  },

  methods: {
    // audio
    onPlay() {
      this.isPause = false;
    },
    onPause() {
      this.isPause = true;
    },
    onEnd() {
      this.isPause = true;
      this.setTime(0);
    },
    loadMeta(e) {
      this.length = e.target.duration * this.timeMagnifier;
    },
    mediaReady() {
      this.isPlayerRender = true;
    },
    mediaDestroy() {
      this.t = 0;
      this.length = 0;
      this.isPause = true;
      this.audioData = null;
      this.timeMagnifier = 1000;
      this.isPlayerRender = false;

      if (!this.$refs.PlayerEl) return;
      this.isPlayerRender = false;
    },
    setTime(v) {
      this.t = v / this.timeMagnifier;
      this.$refs.PlayerEl &&
        (this.$refs.PlayerEl.currentTime = v / this.timeMagnifier);
    },
    timeupdate(e) {
      !this.isSliderHolding &&
        (this.t = e.target.currentTime * this.timeMagnifier);
    },
    sliderMousedown() {
      this.isSliderHolding = true;
    },
    sliderMouseup() {
      this.isSliderHolding = false;
    },
    // controll
    play() {
      this.$refs.PlayerEl.play();
      this.isPause = false;
    },
    pause() {
      this.$refs.PlayerEl.pause();
      this.isPause = true;
    },
    playPause() {
      if (this.$refs.PlayerEl.paused) {
        this.play();
      } else {
        this.pause();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>